import { Link as ChakraLink, Icon, Text, LinkProps as ChakraLinkProps } from '@chakra-ui/react'
import { ElementType } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'

interface NavLinkProps extends ChakraLinkProps {
  icon: ElementType
  path?: string
  children: string
}

export function NavLink({ icon, children, path = '/', ...rest }: NavLinkProps) {
  const { pathname } = useLocation()
  const isActive = pathname === path

  return (
    <ChakraLink
      as={RouterLink}
      to={path}
      display="flex"
      alignItems="center"
      color={isActive ? 'pink.400' : 'gray.50'}
      _hover={{ color: 'pink.400' }}
      {...rest}>
      <Icon as={icon} fontSize="20" />

      <Text ml="4" fontWeight="medium">
        {children}
      </Text>
    </ChakraLink>
  )
}
